import { Box, Flex, HStack, useColorModeValue } from '@cardboard-ui/react';
import { Card, CardProps } from 'components/cards/Card';
import { SpaceIndicator } from 'components/SpaceIndicator';
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { graphql, useFragment } from 'utils/graphClient';
import { SPACE_PATH } from 'utils/routes';
import { SpaceContextCard_space$key } from './__generated__/SpaceContextCard_space.graphql';

const spaceFragment = graphql`
  fragment SpaceContextCard_space on Space {
    id
    ...SpaceIndicator_space
    color {
      light
      dark
    }
  }
`;

interface SpaceContextCardProps extends CardProps {
  space: SpaceContextCard_space$key;
  disableContext?: boolean;
  elementToPlaceRightOfSpacename?: React.ReactElement;
}

export const SpaceContextCard: React.FC<SpaceContextCardProps> = ({
  space,
  children,
  disableContext,
  elementToPlaceRightOfSpacename,
  ...cardProps
}) => {
  const { color, ...fragments } = useFragment(spaceFragment, space);
  const bgColor = useColorModeValue('gray.100', 'gray.600');
  const path = useLocation().pathname;
  const isInSpace = !!matchPath({ path: SPACE_PATH, end: false }, path);

  return (
    <Card overflow="visible" {...cardProps}>
      {!isInSpace && !disableContext && (
        <Flex bg={bgColor} p={1} justifyContent="flex-end" w="100%">
          <HStack spacing={1}>
            <Box px={2}>
              <SpaceIndicator space={fragments} />
            </Box>
            {elementToPlaceRightOfSpacename}
          </HStack>
        </Flex>
      )}
      {children}
    </Card>
  );
};
